export type Page<T> = {
    content: Array<T>,
    pageable: {
        number: number,
        sort: {
            orderBy: Array<string>
        },
        size: number
    },
    totalSize: number,
    totalPages: number,
    empty: boolean,
    size: number,
    offset: number,
    pageNumber: number,
    numberOfElements: number
}

export const emptyPage: Page<any> = {
    content: [],
    pageable: {
        number: 0,
        sort: {
            orderBy: []
        },
        size: 0
    },
    totalSize: 0,
    totalPages: 0,
    empty: true,
    size: 0,
    offset: 0,
    pageNumber: 0,
    numberOfElements: 0
}